(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberAttributes', {
            templateUrl: 'app/member-admin/member-attributes/member-attributes.component.html',
            controller: MemberAttributesComponent,
            bindings: {
                individualId: '<',
                attributes: '<'
            }
        });

    var copy = angular.copy,
        noop = angular.noop;

    MemberAttributesComponent.$inject = ['Member', 'alert', 'confirm', 'memberAdminResources', 'attributeType'];
    function MemberAttributesComponent(Member, alert, confirm, resources, attributeType) {
        var ctrl = this;

        ctrl.insert = insert;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.remove = remove;
        ctrl.cancel = cancel;                
        ctrl.individualId = null;        
        ctrl.datePickerOptions = { minDate: getMinDate(), maxDate: getMaxDate() };

        ctrl.types = Object.keys(attributeType.$metadata);
        ////////////////////////////////////////

        function insert() {
            var attr = { individualId: ctrl.individualId };
            ctrl.attributes.push(attr);
            edit(attr);
        }

        function edit(attr) {
            attr.$clone = angular.copy(attr);
        }


        function save(attr, form) {
            var clone = attr.$clone;
            if (form.$valid)
                Member.saveAttribute({ id: ctrl.individualId }, attr, success, error, true);

            function success(data) {
                copy(data, attr);
                delete attr.$clone;
            }

            function error() {Confir,m
                alert.error(resources.saveAttributeFailed);
            }
        }

        function remove(attr) {
            confirm(resources.confirmDeleteAttribute).then(remove, noop);

            function remove() {                
                Member.deleteAttribute({ id: ctrl.individualId }, attr, success, error, true);

                function success() {
                    removeFromArray(attr);
                }

                function error() {
                    alert.error(resources.deleteAttributeFailed);
                }
            }
        }

        function getData(individualId) {
            return Member.getMemberAttributes({ id: individualId }, success, error);

            function success(data) {
                ctrl.attributes = data;
            }

            function error() {
            }
        }


        function cancel(attr) {
            delete attr.$clone;
            if (!attr.id) {
                removeFromArray(attr);
            }

        }

        function removeFromArray(attr) {
            var index = ctrl.attributes.indexOf(attr);
            if (index !== -1)
                ctrl.attributes.splice(index, 1);
        }

        function getMinDate() {
            var now = new Date();
            now.setYear(now.getFullYear() - 110);
            return now;
        }

        function getMaxDate() {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); // end of day
        }



    }
})();



